module.exports = __webpack_public_path__ + "static/destinations-1eb675b634699ca2a652051ff69b4eb3.jpg";